<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M13.75 13.5987C15.5861 14.2707 16.6616 13.6497 16.9976 11.7237C15.1616 11.0517 14.0861 11.6726 13.75 13.5987ZM13.75 13.5987C11.9178 15.6246 9.08763 15.0922 7.375 17.1244M6.25 13.5984C8.08218 15.6244 10.9124 15.0922 12.625 17.1244M5.91408 3.4375C5.24208 5.27355 5.86302 6.34904 7.78908 6.6851C8.46109 4.84904 7.84016 3.77355 5.91408 3.4375ZM3.29499 7.04499C3.12109 8.99238 3.99922 9.87055 5.94664 9.69663C6.12054 7.74922 5.24241 6.87109 3.29499 7.04499ZM3.00391 11.7244C3.33996 13.6505 4.41544 14.2714 6.2515 13.5994C5.91544 11.6733 4.83996 11.0524 3.00391 11.7244ZM14.0879 3.4375C14.7599 5.27355 14.1389 6.34904 12.2129 6.6851C11.5409 4.84904 12.1619 3.77355 14.0879 3.4375ZM16.6986 7.04499C16.8725 8.99238 15.9944 9.87055 14.0469 9.69663C13.8731 7.74922 14.7512 6.87109 16.6986 7.04499Z" 
    stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'AdRankIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>